/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    UserSelector,
    UserSelectorFromJSON,
    UserSelectorFromJSONTyped,
    UserSelectorToJSON,
} from './';

/**
 * 
 * @export
 * @interface SkipConditions
 */
export interface SkipConditions {
    /**
     * 
     * @type {UserSelector}
     * @memberof SkipConditions
     */
    authors?: UserSelector;
    /**
     * 
     * @type {Array<string>}
     * @memberof SkipConditions
     */
    labels?: Array<string>;
}

export function SkipConditionsFromJSON(json: any): SkipConditions {
    return SkipConditionsFromJSONTyped(json, false);
}

export function SkipConditionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SkipConditions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'authors': !exists(json, 'authors') ? undefined : UserSelectorFromJSON(json['authors']),
        'labels': !exists(json, 'labels') ? undefined : json['labels'],
    };
}

export function SkipConditionsToJSON(value?: SkipConditions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'authors': UserSelectorToJSON(value.authors),
        'labels': value.labels,
    };
}

